/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import {MDBBreadcrumb, MDBBreadcrumbItem} from 'mdbreact'
import {Link} from 'react-router-dom'
import moment from 'moment'
import {saveAs} from 'file-saver'
import FromToPicker from '../BaseComponent/FromToPicker'
import JASPERREPORT from '../BaseComponent/JASPERREPORT'
import Select from 'react-select'
import http from '../Interceptor/Interseptor'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import ORDER_STATUS from '../BaseComponent/ORDERSTATUS'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import AutoComplete from '../BaseComponent/autocomplete'

class CreateProviderPlan extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      providers: [],
      operators: [],
      selectedOperator: {},
      providerId: ''
    }
  }
  componentDidMount() {
    // http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {}).then((response) => {

    //     if (response.data.error == null) {

    //         var result = response.data.object;
    //         for (let i = 0; i < result.length; i++) {
    //             result[i]['value'] = result[i].providerId;
    //             result[i]['label'] ='شناسه :' + result[i].providerId + '-' + result[i].title;
    //         }
    //         this.setState({
    //             providers: response.data.object
    //         })
    //     }
    // }).catch((error) => {
    //     alert(JSON.stringify(error))
    // });
    http.get(`${USER_MANAGE.USER_MANAGE_LIST_OPERATOR}`, {}).then((response) => {
      if (response.data.error === null) {
        var operators = response.data.object
        for (let i = 0; i < operators.length; i++) {
          operators[i]['value'] = operators[i].personId
          operators[i]['label'] = operators[i].personId + ' - ' + operators[i].name
        }
        this.setState({
          operators: response.data.object
        })
      }
    })
  }

  submit(e) {
    e.preventDefault()
  }

  create() {
    let providerId = this.state.providerId
    let operatorId =
      this.state.selectedOperator == null || this.state.selectedOperator == ''
        ? ''
        : this.state.selectedOperator.personId
    let productsWithPlan = document.getElementById('productsWithPlan').value.trim()
    let productsWithoutPlan = document.getElementById('productsWithoutPlan').value.trim()
    if (providerId === '' || productsWithoutPlan === '' || productsWithPlan === '') {
      message.error('لطفا موارد ستاره دار تکمیل شود')
    } else {
      let data = {
        productsWithPlan,
        productsWithoutPlan,
        providerId,
        operatorId
      }
      http.post(`${ORDER_STATUS.ORDER_STATUS_SUPPLIER_PRODUCTS_PLANS}`, data, {}).then((res) => {
        if (res.data.error === null) {
          message.success('با موفقیت ایجاد شد.لطفا صبر کنید')
          setTimeout(() => {
            window.location.assign('/base/orderStatus/provider/plans')
          }, 3000)
        } else {
          message.error(res.data.description)
        }
      })
    }
  }

  handleChange = (selectedOption) => {
    this.setState({selectedOption})
    // alert(JSON.stringify(selectedOption))
    console.log(`Option selected:`, selectedOption)
  }

  changeNumeric = (evt) => {
    if ((evt.which != 8 && evt.which != 0 && evt.which < 48) || evt.which > 57) {
      evt.preventDefault()
    }
  }

  render() {
    let {selectedOption} = this.state

    return (
      <div className="rtl">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>وضعیت سفارشات</li>
            <li>برنامه تامین کنندگان</li>
            <li>افزودن</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)} noValidate>
            <div className="headerVertical">
              <p>افزودن برنامه تامین کننده</p>
            </div>

            <div className="formComponent selectComponent">
              <AutoComplete
                label="تامین کننده"
                api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                textField="title"
                valueField="providerId"
                id="provider"
                value={this.state.providerId}
                setValue={(providerId) => this.setState({providerId})}
                required
              />
              {/* <label>تامین کننده :‌ <span className='requireFiled'>*</span></label>
                            <Select
                                value={selectedOption}
                                onChange={this.handleChange}
                                options={this.state.providers}
                                isMulti={false}
                                isClearable={true}
                                placeholder={''}
                                id="input_supplierName"
                                name="input_supplierName"
                                tabIndex='1'
                            /> */}
            </div>

            <div className="formComponent selectComponent">
              <label>کاربر مسئول :‌ </label>
              <Select
                value={this.state.selectedOperator}
                onChange={(selectedOperator) => this.setState({selectedOperator})}
                options={this.state.operators}
                isMulti={false}
                isClearable={true}
                placeholder={''}
                tabIndex="1"
              />
            </div>

            <div className="formComponent">
              <label>
                دارای برنامه تامین <span className="requireFiled">*</span>‌
              </label>
              <input
                type="number"
                id="productsWithPlan"
                min={0}
                onKeyPress={this.changeNumeric}
                className="form-control"
              />
            </div>

            <div className="formComponent">
              <label>
                بدون برنامه تامین <span className="requireFiled">*</span>‌
              </label>
              <input
                type="number"
                id="productsWithoutPlan"
                min={0}
                onKeyPress={this.changeNumeric}
                className="form-control"
              />
            </div>
            <div className="formComponent">
              <button className="btn btn-info btn-block jasperBtn" onClick={this.create.bind(this)}>
                ایجاد برنامه تامین کننده
              </button>
              <p className="errorText" id="errorText" />
            </div>
          </form>
        </div>
      </div>
    )
  }
}
export default CreateProviderPlan
